import { isNumber } from "./isValueExists";

export const safeDivide = (numerator: number, denominator: number) =>
  denominator ? numerator / denominator : 0;

export const avgOf = <T extends { [key: string]: any }>(
  mediaData: T[],
  avgOf: keyof T
) => {
  let sum = mediaData.reduce((total, num) => {
    return total + (isNumber(num[avgOf]) ? num[avgOf] : 0);
  }, 0);

  return safeDivide(sum, mediaData?.length || 0);
};

export const sumOf = <T extends { [key: string]: any }>(
  mediaData: T[],
  avgOf: keyof T
) => {
  let sum = mediaData.reduce((total, num) => {
    return total + (isNumber(num[avgOf]) ? num[avgOf] : 0);
  }, 0);

  return sum;
};
